import { Modal, List, Checkbox, Tag } from 'antd';
import { JobCluster } from './useJobClustering';
import * as routeAddModel from '../routeAddModel';

type Props = {
  cluster: JobCluster | null;
  selectedJobs: number[];
  onClose: () => void;
  onToggleJobSelection: (jobId: number) => void;
};

const ClusterPopup = ({ cluster, selectedJobs, onClose, onToggleJobSelection }: Props) => {
  const isOpen = cluster !== null;

  return (
    <Modal
      title="Jobs at this location"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={400}
      styles={{
        body: { maxHeight: '400px', overflowY: 'auto' }
      }}
    >
      {cluster && (
        <List
          size="small"
          dataSource={cluster.jobs}
          renderItem={(job) => {
            const isSelected = selectedJobs.includes(job.jobId);
            const hasError = routeAddModel.hasJobError(job);
            const noWorkAreas = routeAddModel.hasNoWorkAreas(job);
            const noApprovedWorkAreas = routeAddModel.hasNoApprovedWorkAreas(job);
            const isDisabled = hasError || noWorkAreas || noApprovedWorkAreas;

            return (
              <List.Item
                style={{
                  padding: '8px 0',
                  cursor: isDisabled ? 'not-allowed' : 'pointer'
                }}
                onClick={() => {
                  if (!isDisabled) {
                    onToggleJobSelection(job.jobId);
                  }
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Checkbox
                    checked={isSelected}
                    disabled={isDisabled}
                    style={{ marginRight: '8px' }}
                  />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      opacity: isDisabled ? 0.5 : 1
                    }}>
                      {job.customerDisplayName}
                    </div>
                    <div style={{ opacity: isDisabled ? 0.5 : 1 }}>
                      {job.jobName}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: '#666',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      opacity: isDisabled ? 0.5 : 1
                    }}>
                      {job.address1}, {job.city}, {job.state} {job.zip}
                    </div>
                    <div style={{ marginTop: '4px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                      {hasError && (
                        <Tag style={{ fontSize: '11px', color: '#000' }}>Incomplete Address</Tag>
                      )}
                      {!hasError && noWorkAreas && (
                        <Tag style={{ fontSize: '11px', color: '#000' }}>No Work Areas</Tag>
                      )}
                      {!hasError && !noWorkAreas && noApprovedWorkAreas && (
                        <Tag style={{ fontSize: '11px', color: '#000' }}>No Approved Work Areas</Tag>
                      )}
                    </div>
                  </div>
                </div>
              </List.Item>
            );
          }}
        />
      )}
    </Modal>
  );
};

export default ClusterPopup;